import React, { useState } from "react";
import { Link } from "gatsby";
import remark from "remark";
import parse from "remark-parse";
import remarkToreact from 'remark-react';
import remarkAttr from 'remark-attr';
import { MDXRenderer } from "gatsby-plugin-mdx";
import { MDXProvider } from "@mdx-js/react";

import Table from "mcc-cms/columns/Table";
import Accordion from "mcc-cms/columns/Accordion";
import Form from "mcc-cms/columns/Form";
import Banner from "mcc-cms/columns/Banner";
import Carousel from "mcc-cms/columns/Carousel";
import BlogRoll from 'mcc-cms/columns/BlogRoll';
import Jumbotron from 'mcc-cms/columns/Jumbotron';
import Map from 'mcc-cms/columns/Map';
import CurrencyConverter from 'mcc-cms/columns/CurrencyConverter';
import BuildDate from 'mcc-cms/columns/BuildDate';
import Checkout from 'mcc-cms/columns/Checkout';
import Calculate from 'mcc-cms/columns/Calculate';
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, EmailIcon, EmailShareButton } from 'react-share';
import { Helmet } from "react-helmet";
import {TemplateWrapper} from "../layout/Layout";
import SEO from "../SEO";
import CaptchaTextReveal from "./CaptchaTextReveal";

const shortcodes = { CurrencyConverter, BuildDate, Checkout, Calculate }

const Chunk = props => {
  return (
    <>
      {props.chunk.map(chunk => (
        <>
          {/* Text */}
          {chunk.type === "text" && (
            <div
              className={`content ${!!chunk.size ? chunk.size : "is-size-13"}`}
              style={{
                textAlign: `${chunk.align}`,
                paddingBottom: `${!!chunk.paddingBottom ? chunk.paddingBottom + "rem" : "2rem"}`,
              }}
            >
              {chunk.hasRecaptcha ? (
                <CaptchaTextReveal
                  hiddenText={
                    remark()
                      .use(parse)
                      .use(remarkAttr)
                      .use(remarkToreact)
                      .processSync(chunk.value).contents
                  }
                  langKey={props.langKey}
                />
              ) : (
                remark()
                  .use(parse)
                  .use(remarkAttr)
                  .use(remarkToreact)
                  .processSync(chunk.value).contents
              )}
            </div>
          )}

          {/* Testimonial */}
          {chunk.type === "featured-testimonial" &&
            <div className="card">
              <div class="card-image" style={{padding: "1.5rem"}}>
                <figure class="image  is-96x128">
                  <img src={!!chunk.image.childImageSharp ? chunk.image.childImageSharp.fluid.src : chunk.image } 
                  alt="client logo"
                  style={{height:"15rem"}}>
                  </img>
                </figure>
              </div>
              <div className="card-content">
                <p className={`title ${!!chunk.size ? chunk.size : "is-size-13"}`} style={{
                  textAlign: `${chunk.align}`,
                }} >
                  {remark().use(parse).use(remarkAttr).use(remarkToreact).processSync(chunk.value).contents}
                </p>
                <div className="card-author">
                  - {chunk.author}
                </div>
                <div className="card-author-title">
                  {chunk.authorTitle}
                </div>
                <div className="card-company-name">
                  {chunk.companyNameLong}
                </div>
              </div>
              <footer className="card-footer">
                <p className="card-footer-item">
                  <span>
                    See full testimony from <a href={chunk.link}>{chunk.companyNameShort}</a>
                  </span>
                </p>
                <div className="card-footer-item">
                  <p style={{padding: "3px"}}>Share:</p>
                  <FacebookShareButton style={{marginTop:"10px", marginLeft:"1px", marginRight: "1px"}}
                    url={"https://maintenanceconnection.ca/testimonies/"+chunk.page+"/"}     //eg. https://www.example.com
                    quotes={remark().use(parse).use(remarkAttr).use(remarkToreact).processSync(chunk.value).contents}  //"Your Quotes"
                  >
                    <FacebookIcon size={32} round/>
                  </FacebookShareButton>  
                  <TwitterShareButton style={{marginTop:"10px", marginLeft:"1px", marginRight: "1px"}}
                    url={"https://maintenanceconnection.ca/testimonies/"+chunk.page+"/"}
                    quotes={remark().use(parse).use(remarkAttr).use(remarkToreact).processSync(chunk.value).contents}          
                  >
                    <TwitterIcon size={32} round/>
                  </TwitterShareButton>
                  {/* <EmailShareButton style={{marginTop:"10px", marginLeft:"1px", marginRight: "1px"}}
                    url={"https://maintenanceconnection.ca/testimonies/"+chunk.page+"/"}
                    quotes={remark().use(parse).use(remarkAttr).use(remarkToreact).processSync(chunk.value).contents}          
                  >
                    <EmailIcon size={32} round/>
                  </EmailShareButton> */}
                </div>
                
                 
              </footer>
            </div>
          }

          {/* Full Testimonial */}
          {chunk.type === "testimonial" && 
            
            <div className="testimonial">
              {/* changes the meta tag og:image and title for the page, recommended image should be 1200×630 pixels*/}
              {chunk.isFeatured ? <SEO title={chunk.value} image={chunk.imageFileLocation} twitterImage={chunk.twitterImageFileLocation} /> : null}
              {console.log(chunk.image)}
              <img className="testimonial-bottom-left" src={"/files/favicon/favicon-32x32.png"}></img>
              <img className="testimonial-top-right" src={"/files/favicon/favicon-32x32.png"}></img>
              <div className="card-content">
              
                <p className={`title ${!!chunk.size ? chunk.size : "is-size-13"}`} style={{
                  textAlign: `${chunk.align}`,
                }} >
                  {remark().use(parse).use(remarkAttr).use(remarkToreact).processSync(chunk.value).contents}
                </p>
              </div>
          </div>
          }

          {/* Image */}
          {chunk.type === "image" &&
            <div
              className="content"
              style={{
                textAlign: `${chunk.align}`,
                paddingBottom: "1.5rem"
              }}
            >
              {chunk.useMap !== null ? (
                <img
                  src={!!chunk.image.childImageSharp ? chunk.image.childImageSharp.fluid.src : chunk.image}
                  width={chunk.width}
                  height={chunk.height}
                  alt={chunk.alt}
                  useMap={"#" + chunk.useMap.mapName}
                />
              ) : (
                <img
                  src={!!chunk.image.childImageSharp ? chunk.image.childImageSharp.fluid.src : chunk.image}
                  width={chunk.width}
                  height={chunk.height}
                  alt={chunk.alt}
                />
              )}
              {chunk.useMap !== null ? (
                <map name={chunk.useMap.mapName}>
                  {chunk.useMap.area.map(area => (
                    <area
                      shape={area.shape}
                      coords={area.coords}
                      href={area.link}
                      alt={area.alt}
                    />
                  ))}
                </map>
              ) : null}
            </div>
          }

          {/* Button */}
          {chunk.type === "button" &&
            <div
              className="content"
              style={{
                textAlign: `${chunk.align}`,
                paddingBottom: '1.5rem',
              }}
            >
              <Link
                to={`${props.langKey === "en" ? "" : props.langKey}${chunk.link}`}
                className="button is-dark is-small"
              >
                {chunk.value}
              </Link>
            </div>
          }

          {/* Table */}
          {chunk.type === "table" &&
            <div
              className="content"
              style={{paddingBottom: "1.5rem"}}
            >
              <Table
                title={chunk.title !== null ? chunk.title : null}
                data={chunk}
              />
            </div>
          }

          {/* Table - New */}
          {chunk.type === "tableNew" &&
            <div
              className={`table is-striped`}
              style={{paddingBottom: "1.5rem"}}
            >
              {remark().use(parse).use(remarkAttr).use(remarkToreact).processSync(chunk.value).contents}
            </div>
          }

          {/* Accordion */}
          {chunk.type === "accordion" &&
            <div
              className="content"
              style={{
                textAlign: `${chunk.align}`,
                paddingBottom: "1.5rem",
              }}
            >
              {chunk.entries.map(entries => (
                <Accordion
                  title={entries.title}
                  content={entries.content}
                />
              ))}
            </div>
          }

          {/* Form */}
          {chunk.type === "form" &&
            <div
              className="content"
              style={{paddingBottom: "1.5rem",}}
            >
              <Form
                data={chunk}
                langKey={props.langKey}
              />
            </div>
          }

          {/* Banner */}
          {chunk.type === "banner" &&
            <div
              className="content"
              style={{paddingBottom: "1.5rem",}}>
              <Banner
                data={chunk}
                langKey={props.langKey}
              />
            </div>
          }

          {/* Carousel */}
          {chunk.type === "carousel" &&
            <div
              style={{paddingBottom: "1.5rem",}}
            >
              <Carousel
                data={chunk}
              />
            </div>
          }

          {/* Blog Roll */}
          {chunk.type === "blogRoll" &&
            <div
              style={{paddingBottom: "1.5rem",}}
            >
              <BlogRoll
                langKey={props.langKey}
                isHome={chunk.isHome}
              />
            </div>
          }

          {/* Jumbotron */}
          {chunk.type === "jumbotron" &&
            <Jumbotron
              data={chunk}
            />
          }

          {/* Map */}
          {chunk.type === "map" &&
            <Map
              data={chunk}
            />
          }

          {/* HTML */}
          {chunk.type === "html" &&
            <div
              className={`content ${!!chunk.size ? chunk.size : "is-size-13"}`}
              style={{
                textAlign: `${chunk.align}`,
                paddingBottom: `${!!chunk.paddingBottom ? (chunk.paddingBottom + "rem") : "2rem"}`,
              }}
              dangerouslySetInnerHTML={{__html: `${chunk.value}`}}
            />
          }

          {/* Include File */}
          {chunk.type === "include" &&
            <>
              {props.reusable.map(reusable => (
                <>
                  {reusable.node.frontmatter.title === chunk.value &&
                    <div
                      className={`content ${!!chunk.size ? chunk.size : "is-size-13"}`}
                      style={{
                        textAlign: `${chunk.align}`,
                        paddingBottom: `${!!chunk.paddingBottom ? (chunk.paddingBottom + "rem") : "2rem"}`,
                      }}
                    >
                      <MDXProvider components={shortcodes}>
                        <MDXRenderer>
                          {reusable.node.body}
                        </MDXRenderer>
                      </MDXProvider>
                    </div>
                  }
                </>
              ))}
            </>
          }
        </>
      ))}
    </>
  );
};

export default Chunk
